module.exports = __webpack_public_path__ + "img/xml-icon.56a5fe5.svg?v=1764327952164";